import { render, staticRenderFns } from "./CampaignStatusBadge.vue?vue&type=template&id=45608688"
import script from "./CampaignStatusBadge.vue?vue&type=script&lang=ts"
export * from "./CampaignStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports